import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { FusionFrameworkComponent } from './pages/fusion-framework/fusion-framework.component';
import { AuthGuard } from './services/auth.guard';

// SKS20DEC24 lazy loading import
const routes: Routes = [
  { path: 'login', loadChildren: () => import('./pages/login/login-routing.module').then(m => m.LoginRoutingModule) },
  { path: 'hire/:companyId/register', loadChildren: () => import('./pages/hire-registration/hire-registration-routing.module').then(m => m.HireRegistrationRoutingModule) },
  { path: 'hrm/:languageCode',loadChildren: () => import('./pages/hrm/hrm-routing.module').then(m => m.HrmRoutingModule), canActivate: [AuthGuard], data: { roles: ['Super User', 'HRM User', 'HRM Manager'] }},
  { path: 'settings/:languageCode', loadChildren: () => import('./pages/settings/settings-routing.module').then(m => m.SettingsRoutingModule), canActivate: [AuthGuard], data: { roles: ['Super User'] }},
  { path: 'ess/:languageCode', loadChildren: () => import('./pages/ess/ess-routing.module').then(m => m.EssRoutingModule), canActivate: [AuthGuard],data:{ roles:['ESS User', 'Super User', 'HRM User', 'HRM Manager'] }},
  { path: 'app/:languageCode/:appName/:moduleName/:tabName', loadChildren: () => import('./pages/park-app/park-app-routing.module').then(m => m.ParkAppRoutingModule), canActivate: [AuthGuard], data: { roles: ['App User', 'Super User'] }},
  { path: 'resetpassword', loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordModule) },
  { path: 'fusion-components', component: FusionFrameworkComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
